var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{class:_vm.$style.footer},[_c('TheContainer',{attrs:{"padding":"0 4px"}},[_c('div',{class:_vm.$style.footerWrap},[_c('div',{staticStyle:{"width":"100%","height":"100%","text-align":"center","line-height":"70px","color":"var(--footer-desc-color)"}},[_c('p',[_vm._v("© TILON INC. ALL RIGHT RESERVED")])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }